export enum XpressRiderStatus {
    None = 1,
    SubmitStarted = 2,
    Submitted = 3,
    OnReview = 4,
    Rejected = 5,
    Approved = 6,
    RegistrationCompleted = 7,
    AppointmentMissed = 8,
    /// <summary>
    /// Когда тренировка провалена
    /// </summary>
    DrivingTestFailed = 9,
    /// <summary>
    /// Когда тренировка назначена
    /// </summary>
    TrainingScheduled = 10,
    /// <summary>
    /// Когда тренировка подтверждена
    /// </summary>
    DrivingTestPassed = 11,
    ActivationPending = 12,
    ActivationFailed = 13,
    /// <summary>
    /// Когда райдер не пришел на тренировку
    /// </summary>
    TrainingAppointmentMissed = 14,

    /// <summary>
    /// Used становится после RegistrationCompleted
    /// Значит райдер может пользоваться приложением
    /// </summary>
    Used = 15,

    /// <summary>
    /// Когда райдер изменил документы и отправил на проверку
    /// </summary>
    Resubmission = 16,

    /// <summary>
    /// Статус становится когда загрузили документы TNVC и Nationality и отправили на проверку
    /// </summary>
    DocumentPrescreening = 17,

    /// <summary>
    /// Статус становится после прохождения первого экзамена в классе и если типы Ride - Moto
    /// </summary>
    SchedulingDrivingTime = 18,

    /// <summary>
    /// Статус становится при вызове апи UpdateRidesharingApp и передать поле UseAnotherRidesharingApp = false
    /// </summary>
    VisitOfficeForProvisionalAuthority = 19,

    Invited = 20,

    OnHold = 21,
}
